import React from "react";

const BasicBodyTheme = (WrappedComponent) => (props) => {
  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <h1>Header1</h1>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="card card-primary card-outline">
              <div className="card-body box-profile">
                {/* FORM */}
                <WrappedComponent {...props} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BasicBodyTheme;
